export const removeTrailingSlash = (inputUrl: string): string => {
  if (inputUrl.slice(-1) === "/")
    return inputUrl.substring(0, inputUrl.length - 1)
  return inputUrl
}
